import { render, staticRenderFns } from "./HeadSort.vue?vue&type=template&id=22b92486&"
import script from "./HeadSort.vue?vue&type=script&lang=js&"
export * from "./HeadSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('22b92486', component.options)
    } else {
      api.reload('22b92486', component.options)
    }
    module.hot.accept("./HeadSort.vue?vue&type=template&id=22b92486&", function () {
      api.rerender('22b92486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/datatable/Table/HeadSort.vue"
export default component.exports